import React from 'react'
import './CrossClientRowSkeleton.scss'

interface CrossClientRowSkeletonProps {
  count: number
}

export const CrossClientRowSkeleton: React.FC<CrossClientRowSkeletonProps> = ({ count }) => (
  <div className='d-flex flex-column gap-2 w-100'>
    {Array.from({ length: count }, (_, index) => (
      <div key={index} className='skeleton w-100 cross-client-row-skeleton' />
    ))}
  </div>
)
